<template>
	<!-- 테이블 컨텐츠 -->
	<div>
		<div class="d_flex mb_20">
			<div class="back_btn" @click="$emit('showDealList')">
				<span class="LEFTARROW"></span>
				<h3 class="ml_15">{{ $t('rtr_activity-c2c.title3') }}</h3>
			</div>
		</div>

		<!--			<div class="title mb_20 mt_20 d_flex align_items_center"></div>-->
		<div class="table" v-if="dealDetailList.length > 0">
			<!-- 테이블 컨텐츠 -->
			<div class="table_item" v-for="item in dealDetailList" :key="item.seq">
				<div class="list_item">
					<div class="list_num">{{ item._no }}</div>
					<div class="item_box">
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.sold_asset') }}</p>
							<div class="asset_box mb_10">
								<span :class="[item.source_asset_codem, 'small']"></span>
								<p class="code mr_4">{{ item.source_asset_code }}</p>
								<p class="name">{{ item.source_asset_title }}</p>
							</div>
							<p class="fs_12 fc_gray2">
								{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
							</p>
						</div>
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.registered_quantity') }}</p>
							<p>{{ item.source_amount }}</p>
						</div>
						<div class="item tal">
							<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
							<p>
								1 <span class="fs_12">{{ item.source_asset_code }} = </span>
							</p>
							<p>
								{{ item.price }}
								<span class="fs_12">{{ item.target_asset_code }}</span>
							</p>
						</div>
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
							<div class="asset_box mb_10">
								<span :class="[item.target_asset_code, 'small']"></span>
								<p class="code mr_4">{{ item.target_asset_code }}</p>
								<p class="name">{{ item.target_asset_title }}</p>
							</div>
						</div>
					</div>
					<div class="status_area d_flex align_items_center">
						<div :class="'status ' + item.status">
							<span class="icon"></span>
							<span>{{ $t('c2c.' + item.status) }}</span>
						</div>
					</div>
				</div>

				<!-- 테이블 컨텐츠2 -->
				<div class="list_item2">
					<div class="d_flex w30">
						<div class="item">
							<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
							<p>{{ item.fee_amount }}</p>
						</div>
						<div class="item ma_0">
							<p>{{ $t('rtr_activity-c2c.charge_fee') }}</p>
							<p>{{ item.deal_fee_amount }}</p>
						</div>
					</div>
					<div class="btn_area">
						<button class="button_bg_black" @click="$emit('showDetail', item)">
							{{ $t('button.detail') }}
						</button>
						<template
							v-if="
								item.escrow_type === 'DEALER' || item.escrow_type === 'DISABLE'
							"
						>
							<button
								class="blue2"
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
							>
								{{ $t('button.decide') }}
							</button>
							<button
								class="black"
								v-if="item.status === 'PENDING'"
								@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
							>
								{{ $t('button.reject') }}
							</button>
						</template>
						<template v-if="item.escrow_type === 'APPLICANT'">
							<button
								class="button_bg_red"
								v-if="item.status === 'PENDING'"
								@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
							>
								{{ $t('button.payment') }}
							</button>
							<button
								class="black"
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
							>
								{{ $t('button.reject') }}
							</button>
						</template>
					</div>
				</div>
			</div>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</div>
		<div v-else>
			<div class="list_none" v-if="!loading">
				<span class="ERRORGRAY"></span>
				<p>{{ $t('rtr_activity-c2c.empty2') }}</p>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import Pagination from '@/components/Pagination';
import ModalMessage from '@/components/Layout/ModalMessage';
import {
	confirmPrivateApplication,
	fetchPrivateApplications,
	payPrivateApplication,
	rejectPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
export default {
	name: 'SaleDetailList',
	emits: ['showDealList', 'showDetail'],
	props: {
		dealSeq: {
			type: Number,
		},
	},
	components: {
		Pagination,
		ModalMessage,
	},
	data() {
		return {
			dealDetailList: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			patchSeq: null,
			patchType: '',
			loading: false,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadDealDetailList();
		},
		async loadDealDetailList() {
			this.loading = true;
			const params = {
				page: this.curPage,
				list_count: this.listCount,
				deal_seq: this.dealSeq,
			};
			const { data, page_navigation } = await fetchPrivateApplications(
				params,
			).catch(commonError);
			this.loading = false;
			this.dealDetailList = data;
			this.pageNavigation = page_navigation;
		},
		privateApplicationHandler(seq, type) {
			this.patchSeq = seq;
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_REJECTED':
					message = this.$t('modal.message.set_reject');
					break;
				case 'SET_PAYED':
					message = this.$t('modal.message.set_pay');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('modal.message.set_confirm');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message;
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_REJECTED':
					this.rejectPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async rejectPrivateApplication() {
			await rejectPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_reject');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDealDetailList();
		},
	},
};
</script>
<style scoped></style>
